import HttpService from "./HttpService";
const API_ENDPOINT = "/employee-benefit-information-edit";

const EmployeeBenefitService = {
  async getDetails(id) {
    try {
      const response = await HttpService.get(`${API_ENDPOINT}/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default EmployeeBenefitService;
